module.exports = __webpack_public_path__ + "9a7e5aac355714740999e3b461fbfd4c.jpg";